"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4965],{

/***/ 94965:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _emotion_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97133);
/* harmony import */ var _prezzee_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34906);
/* harmony import */ var _prezzee_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_prezzee_components__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(53126);
/* harmony import */ var _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67814);
/* harmony import */ var _prezzee_ribbon_ui_lib_components_Box__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(18636);
/* harmony import */ var contexts_ProductPageContext__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16029);
/* harmony import */ var react_markdown__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(20949);









var style = {
    dialogTrigger: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("text-decoration:underline;color:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.colors.notificationBlue, ";width:fit-content;margin-top:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.spacing.spacing04, ";:hover{cursor:pointer;}"),
    dialog: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("[role='dialog']{padding:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.spacing.spacing06, ";max-height:50%;max-width:448px;}"),
    close: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("width:30px;height:30px;border-radius:50%;background-color:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.colors.lilac50, ";position:absolute;right:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.spacing.spacing06, ";top:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.spacing.spacing06, ";"),
    title: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("margin-bottom:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.spacing.spacing05, " !important;padding-right:35px;"),
    terms: /*#__PURE__*/ (0,_emotion_css__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("white-space:pre-wrap;a{color:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.colors.blue500, ";text-decoration:underline;&:hover{color:", _prezzee_tokens__WEBPACK_IMPORTED_MODULE_3__.colors.blue600, ";}}")
};
var RetailerTnCModal = function() {
    var sku = (0,contexts_ProductPageContext__WEBPACK_IMPORTED_MODULE_6__/* .useProduct */ .i)().sku;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), retailerTnCModalOpen = ref[0], setRetailerTnCModalOpen = ref[1];
    var handleClose = function() {
        return setRetailerTnCModalOpen(false);
    };
    var terms = sku === null || sku === void 0 ? void 0 : sku.merchant.terms;
    if (!terms) return null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("button", {
                onClick: function() {
                    setRetailerTnCModalOpen(true);
                },
                className: style.dialogTrigger,
                children: "Terms & Conditions"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsxs)(_prezzee_components__WEBPACK_IMPORTED_MODULE_2__.Dialog, {
                open: retailerTnCModalOpen,
                "aria-labelledby": "retailer-terms-and-conditions",
                className: style.dialog,
                onClose: handleClose,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)("button", {
                        className: style.close,
                        onClick: handleClose,
                        title: "Close retailer terms and conditions dialog",
                        "aria-label": "Close retailer terms and conditions dialog",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_4__.FontAwesomeIcon, {
                            icon: [
                                "far",
                                "times"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_prezzee_components__WEBPACK_IMPORTED_MODULE_2__.Typography, {
                        variant: "h4",
                        component: "h3",
                        id: "retailer-list-dialog-title",
                        className: style.title,
                        children: "".concat(sku.name, " eGift Card Terms and Conditions")
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(_prezzee_ribbon_ui_lib_components_Box__WEBPACK_IMPORTED_MODULE_5__["default"], {
                        className: style.terms,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_7__.jsx)(react_markdown__WEBPACK_IMPORTED_MODULE_8__/* .Markdown */ .UG, {
                            children: terms
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (RetailerTnCModal);


/***/ })

}]);